import React, { useEffect, useState } from 'react'
import RichTextEditor from '../common/RichTextEditor'
import RichTextEditorArea from '../common/RichTextEditorArea';

// Make this component work as a controlled component when `value` and `onChange`
// are provided by the parent (LeadDetail). It also supports an internal state
// when used standalone via the `reset` prop.
const AddNotes = ({ reset, value = '', onChange }) => {
    const [noteText, setNoteText] = useState(value || '');

    // Update internal state when parent-controlled value changes
    useEffect(() => {
        setNoteText(value || '');
    }, [value]);

    // Reset when requested
    useEffect(() => {
        if (reset) {
            setNoteText('');
            if (typeof onChange === 'function') onChange('');
        }
    }, [reset]);

    // Accept either the event-like object from RichTextEditorArea or a raw string
    const handleChange = (payload) => {
        const newVal = payload && payload.target && typeof payload.target.value !== 'undefined'
            ? payload.target.value
            : (typeof payload === 'string' ? payload : '');

        setNoteText(newVal);
        if (typeof onChange === 'function') onChange(newVal);
    };

    return (
        <div>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Note <span className="text-red-500">*</span>
                    </label>
                    <RichTextEditorArea
                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none`}
                        value={noteText}
                        onChange={handleChange}
                        placeholder="Enter your note here..."
                        rows="8"
                    />
                </div>
            </div>
        </div>
    )
}

export default AddNotes
